<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            老人自带药品记录
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            style="margin-right:10px;"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期" class="search">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期" class="search">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
                
            </div>
            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column label="姓名" prop="elderlyName" width="200"></el-table-column>
                        <el-table-column label="备注" prop="remarks" ></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" label="创建时间"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:zoneValue="zoneValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    </div>
</template>

<script>

    import {timeStr,timefilters,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                menuButtonList:null,
                disabledAdd:true,
                batchDialog:false,
                tableData:null,
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
                elderlyName:null,
                rechargeType:0,
                batchFileList:[],
                zoneValue:[],
                datetimerangeValue:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
            }
        },
        components:{
            Add
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                var rechargeType=this.rechargeType
                if(rechargeType==0){
                    rechargeType-=1
                }else{
                    rechargeType+=1
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ElderlyDrugRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        startTime:this.startTime,
                        endTime:this.endTime,    
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            submitUpload(){
                this.$refs.upload.submit();
            },
            closeBatchDialog(){
                this.$refs.upload.clearFiles();
            },
            handleRemove(){

            },
        }
    }
</script>

<style scoped>

</style>
